/* eslint-disable max-len */
import React from 'react';

function PriorAuthIcon({
  width = 24,
  height = 24,
  ...rest
}: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width={width}
      height={height}
      viewBox="0 0 200.000000 200.000000"
      preserveAspectRatio="xMidYMid meet"
      {...rest}>
      <g
        transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
        stroke="none">
        <path d="M280 1000 l0 -940 655 0 655 0 0 65 0 65 -30 0 c-27 0 -30 -3 -30 -30 l0 -30 -595 0 -595 0 0 870 0 870 485 0 485 0 0 -105 0 -105 110 0 110 0 0 -235 0 -235 30 0 30 0 0 257 0 258 -117 117 -118 118 -537 0 -538 0 0 -940z m1155 770 l49 -50 -52 0 -52 0 0 50 c0 28 1 50 3 50 1 0 25 -22 52 -50z" />
        <path d="M720 1750 l0 -30 220 0 220 0 0 30 0 30 -220 0 -220 0 0 -30z" />
        <path d="M465 1565 c-23 -22 -25 -31 -25 -125 0 -100 1 -102 30 -132 30 -30 30 -30 131 -26 96 3 102 4 125 31 18 22 24 40 24 78 0 48 -1 49 -30 49 -28 0 -30 -2 -30 -38 0 -21 -5 -43 -12 -50 -18 -18 -152 -16 -167 2 -8 9 -11 43 -9 93 l3 78 43 3 c39 3 42 5 42 33 0 28 -1 29 -50 29 -41 0 -56 -5 -75 -25z" />
        <path d="M620 1505 l-74 -75 22 -22 22 -23 77 77 c76 76 77 77 58 98 -10 11 -21 20 -24 20 -4 0 -40 -34 -81 -75z" />
        <path d="M810 1500 l0 -30 315 0 315 0 0 30 0 30 -315 0 -315 0 0 -30z" />
        <path d="M814 1396 c-3 -8 -4 -23 -2 -33 3 -17 22 -18 313 -18 l310 0 0 30 0 30 -308 3 c-262 2 -308 0 -313 -12z" />
        <path d="M510 1120 c-59 -14 -70 -38 -70 -151 0 -89 2 -100 24 -126 23 -26 30 -28 114 -31 133 -6 172 21 172 119 0 37 -2 39 -29 39 -28 0 -30 -3 -33 -42 l-3 -43 -90 0 -90 0 0 85 0 85 43 3 c41 3 42 4 42 38 0 37 -9 40 -80 24z" />
        <path d="M1365 1103 c-162 -58 -269 -184 -296 -351 -51 -309 254 -575 552 -482 213 65 345 271 310 483 -24 145 -117 267 -251 331 -57 27 -78 31 -165 33 -77 3 -112 -1 -150 -14z m298 -81 c133 -66 209 -186 209 -332 0 -72 -32 -190 -51 -190 -4 0 -23 32 -41 71 -36 73 -55 90 -117 103 l-32 7 15 41 c17 48 18 142 3 187 -16 46 -53 61 -149 61 -96 0 -133 -15 -149 -61 -15 -45 -14 -139 3 -187 17 -46 16 -47 -36 -56 -43 -8 -72 -39 -107 -114 -14 -29 -28 -52 -32 -52 -4 0 -17 26 -29 58 -31 82 -25 215 14 290 73 143 194 215 353 209 67 -3 92 -9 146 -35z m-89 -118 c21 -8 22 -144 1 -204 -22 -63 -20 -67 38 -80 28 -6 60 -14 70 -17 10 -2 35 -40 58 -85 l40 -80 -23 -25 c-12 -13 -56 -41 -97 -61 -68 -33 -81 -36 -160 -36 -72 0 -95 4 -144 27 -32 15 -76 41 -98 57 l-38 31 41 84 42 84 70 17 c39 9 72 18 74 19 2 1 -6 27 -18 56 -23 63 -29 204 -7 212 18 8 133 8 151 1z" />
        <path d="M620 1035 c-73 -74 -74 -74 -55 -95 l19 -21 78 78 c73 72 76 78 61 95 -9 10 -19 18 -22 18 -4 0 -40 -34 -81 -75z" />
        <path d="M810 1030 l0 -30 125 0 125 0 0 30 0 30 -125 0 -125 0 0 -30z" />
        <path d="M812 908 l3 -33 93 -3 92 -3 0 36 0 35 -96 0 -95 0 3 -32z" />
        <path d="M493 645 c-17 -7 -36 -22 -42 -34 -14 -26 -14 -196 0 -223 16 -29 70 -48 142 -48 115 0 157 32 157 120 0 38 -2 40 -29 40 -28 0 -30 -3 -33 -42 l-3 -43 -90 0 -90 0 0 85 0 85 43 3 c41 3 42 4 42 38 0 32 -2 34 -32 34 -18 -1 -47 -7 -65 -15z" />
        <path d="M617 572 l-78 -78 24 -22 23 -22 77 78 78 78 -24 22 -23 22 -77 -78z" />
        <path d="M810 560 l0 -30 80 0 80 0 0 30 0 30 -80 0 -80 0 0 -30z" />
        <path d="M810 440 l0 -30 95 0 95 0 0 30 0 30 -95 0 -95 0 0 -30z" />
      </g>
    </svg>
  );
}

export default PriorAuthIcon;
